var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect, _ellipse, _rect2, _ellipse2, _path20, _path21, _path22, _line, _line2, _line3, _path23, _rect3, _ellipse3, _path24, _path25, _line4, _line5, _line6, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGiftOpenMoneyWB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 598,
    viewBox: "0 0 601 598",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 305.367,
    cy: 298.367,
    r: 295,
    fill: "#D8E1E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M488.68 399.723L475.123 394.18L467.852 414.941L477.237 418.778L488.68 399.723Z",
    fill: "#5481C2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M115.94 578.812L126.654 588.797L140.808 571.957L133.39 565.045L115.94 578.812Z",
    fill: "#FFD700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M267.568 35.5752L253.158 32.9583L250.341 54.7747L260.317 56.5865L267.568 35.5752Z",
    fill: "#16DFAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.244 104.796L104.721 110.42L114.197 130.272L123.559 126.378L118.244 104.796Z",
    fill: "#FFD700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M542.572 200.792L528.024 199.102L526.607 221.053L536.679 222.224L542.572 200.792Z",
    fill: "#16DFAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M467.603 509.228L453.055 507.537L451.638 529.489L461.71 530.659L467.603 509.228Z",
    fill: "#16DFAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8347 524.792L71.9099 520.253L66.173 541.49L75.8133 544.632L85.8347 524.792Z",
    fill: "#16DFAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M439.47 110.77L429.203 100.326L414.327 116.531L421.435 123.762L439.47 110.77Z",
    fill: "#FFD700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M544.538 314.424L535.04 303.275L519.048 318.38L525.623 326.098L544.538 314.424Z",
    fill: "#F04758"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M429.854 178.403L444.22 175.556L447.386 197.324L437.44 199.296L429.854 178.403Z",
    fill: "#F04758"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145.632 240.548L130.995 241.069L132.903 262.984L143.036 262.623L145.632 240.548Z",
    fill: "#5481C2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6262 313.381L48.2473 312.53L48.3998 334.527L38.2775 335.116L33.6262 313.381Z",
    fill: "#5481C2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M352.04 109.478L366.661 108.626L366.814 130.624L356.691 131.213L352.04 109.478Z",
    fill: "#5481C2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M494.433 132.557L507.032 140.025L494.86 158.349L486.138 153.178L494.433 132.557Z",
    fill: "#5481C2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.746 195L34.3834 195.497L32.5114 217.415L22.3778 217.071L19.746 195Z",
    fill: "#16DFAD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M198.428 61.788L213 63.2549L209.679 85.0003L199.59 83.9848L198.428 61.788Z",
    fill: "#FFD700"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9197 445.026L52.1057 435.149L67.7532 419.688L75.2398 426.526L62.9197 445.026Z",
    fill: "#F04758"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M244.869 226.726L232.2 219.377L222.152 238.946L230.922 244.033L244.869 226.726Z",
    fill: "#F04758"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M183.251 405.254L116.331 291.562L309.871 267.798L418.136 376.413L183.251 405.254Z",
    fill: "#834C17",
    fillOpacity: 0.96,
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 295.602,
    y: 364.712,
    width: 108.683,
    height: 51.6647,
    transform: "rotate(-27 295.602 364.712)",
    fill: "#B5F1DB",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 355.368,
    cy: 362.311,
    rx: 20.1243,
    ry: 19.2858,
    transform: "rotate(-27 355.368 362.311)",
    fill: "#00BC7A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 175.082,
    y: 448.929,
    width: 108.683,
    height: 51.6647,
    transform: "rotate(-61.028 175.082 448.929)",
    fill: "#B5F1DB",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 223.27,
    cy: 413.494,
    rx: 20.1243,
    ry: 19.2858,
    transform: "rotate(-61.028 223.27 413.494)",
    fill: "#00BC7A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M299.878 342.728L287.022 335.712L277.487 355.535L286.387 360.393L299.878 342.728Z",
    fill: "#FFD700"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M325.099 290.102C326.176 298.87 324.601 307.059 321.26 313.2C317.917 319.345 312.882 323.333 307.026 324.052C301.169 324.771 295.319 322.119 290.589 316.966C285.862 311.815 282.353 304.251 281.276 295.483C280.199 286.714 281.774 278.526 285.115 272.384C288.458 266.24 293.493 262.252 299.349 261.533C305.206 260.814 311.056 263.465 315.786 268.618C320.513 273.769 324.022 281.333 325.099 290.102Z",
    fill: "#F7902D",
    stroke: "black",
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M334.782 288.913C335.858 297.681 334.284 305.87 330.942 312.011C327.6 318.156 322.565 322.144 316.708 322.863C310.852 323.582 305.002 320.93 300.272 315.777C295.544 310.626 292.035 303.062 290.959 294.294C289.882 285.525 291.457 277.337 294.798 271.195C298.141 265.051 303.176 261.063 309.032 260.344C314.889 259.625 320.738 262.276 325.468 267.429C330.196 272.58 333.705 280.144 334.782 288.913Z",
    fill: "#FAC689",
    stroke: "black",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 285.039,
    y1: 271.73,
    x2: 294.722,
    y2: 270.541,
    stroke: "black",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 281.079,
    y1: 292.849,
    x2: 290.762,
    y2: 291.66,
    stroke: "black",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 288.695,
    y1: 314.84,
    x2: 298.377,
    y2: 313.651,
    stroke: "black",
    strokeWidth: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M316.518 297.636C316.437 296.466 316.137 295.543 315.618 294.866C315.109 294.175 314.274 293.547 313.116 292.981C311.957 292.416 310.953 291.855 310.103 291.298C309.253 290.727 308.509 290.076 307.874 289.344C307.247 288.598 306.735 287.721 306.337 286.714C305.949 285.706 305.707 284.503 305.611 283.105C305.446 280.693 305.864 278.707 306.866 277.147C307.868 275.586 309.279 274.661 311.098 274.372L310.783 269.792L313.246 269.749L313.565 274.393C315.405 274.718 316.899 275.75 318.046 277.487C319.191 279.21 319.86 281.462 320.051 284.245L315.603 284.323C315.485 282.611 315.141 281.338 314.57 280.505C314.009 279.658 313.302 279.241 312.45 279.256C311.609 279.271 310.981 279.618 310.565 280.296C310.148 280.961 309.98 281.878 310.061 283.048C310.135 284.133 310.421 284.999 310.917 285.648C311.414 286.296 312.296 286.952 313.564 287.616C314.842 288.279 315.898 288.911 316.73 289.511C317.561 290.096 318.275 290.769 318.872 291.531C319.467 292.277 319.943 293.14 320.298 294.12C320.652 295.085 320.873 296.217 320.962 297.516C321.129 299.942 320.721 301.92 319.737 303.452C318.753 304.984 317.316 305.902 315.427 306.206L315.719 310.466L313.272 310.509L312.981 306.27C310.856 305.993 309.154 304.987 307.874 303.253C306.603 301.503 305.867 299.166 305.666 296.241L310.114 296.163C310.231 297.861 310.608 299.161 311.245 300.065C311.892 300.953 312.759 301.388 313.846 301.369C314.749 301.353 315.44 301.013 315.918 300.347C316.395 299.667 316.595 298.764 316.518 297.636Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 346.972,
    y: 232.017,
    width: 108.683,
    height: 51.6647,
    transform: "rotate(-6.51976 346.972 232.017)",
    fill: "#B5F1DB",
    stroke: "black",
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.8,
    cy: 250.68,
    rx: 20.1243,
    ry: 19.2858,
    transform: "rotate(-6.51976 403.8 250.68)",
    fill: "#00BC7A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M446.044 306.484C448.17 323.796 463.439 336.079 480.056 334.039C496.674 331.998 508.517 316.386 506.392 299.075C504.266 281.763 488.998 269.48 472.38 271.52C455.762 273.56 443.919 289.172 446.044 306.484Z",
    fill: "#F7902D",
    stroke: "black",
    strokeWidth: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M432.944 308.093C435.07 325.404 450.339 337.688 466.956 335.647C483.574 333.607 495.417 317.995 493.292 300.683C491.166 283.371 475.897 271.088 459.28 273.128C442.662 275.169 430.819 290.781 432.944 308.093Z",
    fill: "#FAC689",
    stroke: "black",
    strokeWidth: 3
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 13.2001,
    y2: -1.5,
    transform: "matrix(-0.992546 0.121869 0.121869 0.992546 494.328 278.777)",
    stroke: "black",
    strokeWidth: 3
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 13.2001,
    y2: -1.5,
    transform: "matrix(-0.992546 0.121869 0.121869 0.992546 505.558 298.031)",
    stroke: "black",
    strokeWidth: 3
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -1.5,
    x2: 13.2001,
    y2: -1.5,
    transform: "matrix(-0.992546 0.121869 0.121869 0.992546 501.781 321.42)",
    stroke: "black",
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M468.227 309.727C468.025 308.57 467.552 307.706 466.805 307.135C466.07 306.547 464.908 306.09 463.319 305.763C461.73 305.436 460.346 305.082 459.169 304.7C457.989 304.304 456.946 303.805 456.04 303.202C455.145 302.584 454.392 301.811 453.78 300.883C453.183 299.953 452.763 298.796 452.523 297.414C452.107 295.03 452.505 292.951 453.714 291.178C454.924 289.405 456.729 288.185 459.129 287.518L458.341 282.99L461.618 282.436L462.418 287.028C464.897 286.972 466.97 287.697 468.638 289.201C470.304 290.692 471.376 292.812 471.855 295.563L465.935 296.564C465.64 294.871 465.078 293.666 464.251 292.949C463.434 292.215 462.459 291.944 461.325 292.136C460.205 292.325 459.396 292.803 458.897 293.57C458.395 294.323 458.245 295.278 458.447 296.435C458.633 297.507 459.084 298.317 459.798 298.864C460.512 299.412 461.74 299.887 463.483 300.289C465.24 300.689 466.697 301.104 467.854 301.533C469.009 301.948 470.015 302.475 470.871 303.115C471.725 303.74 472.428 304.507 472.98 305.416C473.53 306.311 473.916 307.4 474.14 308.684C474.558 311.082 474.173 313.151 472.986 314.891C471.798 316.632 469.958 317.85 467.464 318.547L468.198 322.759L464.94 323.309L464.211 319.119C461.357 319.282 459.007 318.626 457.162 317.151C455.328 315.66 454.159 313.469 453.655 310.577L459.575 309.576C459.868 311.255 460.475 312.481 461.397 313.255C462.33 314.012 463.521 314.269 464.968 314.024C466.17 313.821 467.063 313.336 467.646 312.569C468.227 311.789 468.421 310.841 468.227 309.727Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M190.598 589.912L181.776 406.202L419.46 377.018L416.456 555.929L190.598 589.912Z",
    fill: "#FAC689",
    stroke: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M119.626 472.256L116.196 292.659L183.233 405.604L189.559 588.576L119.626 472.256Z",
    fill: "#FAC689",
    stroke: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M141.069 507.404L138.205 329.909L151.029 351.357L152.832 527.915L141.069 507.404Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M280.545 576.157L281.29 394.223L325.105 388.844L324.239 569.808L280.545 576.157Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M381.268 381.808L417.496 377.36L415.214 556.745L366.977 562.668L381.268 381.808Z",
    fill: "#F7902D",
    fillOpacity: 0.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M174.961 355.863L156.902 318.559L372.368 195.306L390.572 235.372L174.961 355.863Z",
    fill: "#FAC689",
    stroke: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7969 273.725L46.8614 231.856L158.619 318.543L173.593 355.076L64.7969 273.725Z",
    fill: "#FAC689",
    stroke: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M157.986 318.235L47.7606 232.52L251.352 118.746L371.63 194.581L157.986 318.235Z",
    fill: "#FAC689",
    stroke: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8092 265.804L295.608 146.837L316.457 159.737L105.953 278.794L87.8092 265.804Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M260.175 307.943L244.523 268.224L283.058 246.689L298.71 286.409L260.175 307.943Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M244.042 267.344L186.936 231.672L224.383 210.746L282.083 245.527L244.042 267.344Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M102.868 301.829L87.3884 265.986L105.996 278.026L121.548 316.406L102.868 301.829Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M138.917 149.602L138.936 149.611L138.955 149.618C141.585 150.585 146.304 153.331 151.877 157.239C157.435 161.138 163.803 166.164 169.722 171.662C175.644 177.163 181.1 183.121 184.849 188.879C188.579 194.609 190.558 200.049 189.753 204.613C182.525 214.166 169.06 217.525 154.399 217.557C139.719 217.589 123.998 214.283 112.562 210.71C97.101 205.879 82.2832 194.994 72.5722 183.206C67.7176 177.313 64.1584 171.218 62.4252 165.567C60.6914 159.915 60.7988 154.762 63.1856 150.683C66.2526 145.442 69.9887 141.606 74.479 139.075C78.9701 136.543 84.2464 135.299 90.4195 135.291C102.787 135.275 118.693 140.217 138.917 149.602Z",
    fill: "#FAC689",
    stroke: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M135.076 166.358L135.095 166.367L135.114 166.374C137.744 167.342 142.464 170.087 148.036 173.995C153.595 177.894 159.963 182.921 165.881 188.419C171.803 193.919 177.259 199.877 181.008 205.635C184.738 211.365 186.718 216.805 185.912 221.369C178.684 230.922 165.219 234.281 150.558 234.313C135.879 234.345 120.158 231.039 108.721 227.466C93.2603 222.635 78.4425 211.75 68.7315 199.962C63.8769 194.069 60.3177 187.974 58.5845 182.323C56.8507 176.671 56.9581 171.518 59.3449 167.439C62.4119 162.198 66.148 158.362 70.6383 155.831C75.1294 153.299 80.4057 152.055 86.5787 152.047C98.946 152.031 114.852 156.974 135.076 166.358Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M234.905 107.421C228.148 116.858 222.731 131.943 215.948 154.294C214.813 159.925 212.621 172.516 212.967 184.56C213.14 190.591 213.949 196.451 215.825 201.221C217.683 205.947 220.567 209.558 224.877 211.253C236.912 210.116 248.388 203.703 257.607 194.663C266.855 185.594 273.794 173.915 276.728 162.367C280.735 146.592 282.614 130.261 280.645 117.545C279.66 111.189 277.72 105.773 274.638 101.78C271.571 97.8065 267.358 95.2189 261.756 94.5188C255.678 94.3872 250.649 95.2783 246.309 97.3544C241.965 99.4324 238.274 102.715 234.905 107.421Z",
    fill: "#FAC689",
    stroke: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M215.107 109.682C208.35 119.119 202.933 134.204 196.15 156.555C195.015 162.187 192.823 174.777 193.169 186.821C193.342 192.852 194.151 198.713 196.027 203.483C197.884 208.208 200.768 211.819 205.079 213.515C217.113 212.377 228.589 205.965 237.808 196.924C247.056 187.855 253.996 176.176 256.93 164.628C260.937 148.853 262.816 132.522 260.846 119.807C259.862 113.451 257.922 108.034 254.84 104.041C251.773 100.068 247.56 97.4801 241.957 96.78C235.88 96.6484 230.851 97.5395 226.511 99.6157C222.167 101.694 218.476 104.976 215.107 109.682Z",
    fill: "#F7902D",
    stroke: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M223.768 194.973C226.69 200.201 226.264 205.983 223.303 211.492C220.337 217.012 214.831 222.234 207.659 226.242C200.513 230.236 192.849 231.676 186.247 230.796C179.644 229.916 174.137 226.726 171.209 221.488C168.288 216.26 168.714 210.478 171.674 204.969C174.64 199.449 180.146 194.227 187.318 190.219C194.465 186.225 202.128 184.785 208.731 185.665C215.333 186.545 220.841 189.735 223.768 194.973Z",
    fill: "#F7902D",
    stroke: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftOpenMoneyWB);
export default __webpack_public_path__ + "static/media/gift_open_money_w_b.c7c8d755bd1ae4feae18e1078b6e7224.svg";
export { ForwardRef as ReactComponent };